module.exports = __webpack_public_path__ + "static/media/airoptix.6d216fa8.png";